<template>
  <div>
    <v-row>
      <v-col cols="12" md="4">
        <div class="pb-4">Courses Thumbnail required <br />(300 x 400 px)</div>
        <div>
          <!-- style="overflow: hidden" -->
          <div @click="UploadImg1">
            <div class="dashed" v-if="Src1 == null">
              <div class="d-flex justify-center py-14">
                <div class="my-16">
                  <camerasvg />
                </div>
              </div>
            </div>
            <v-card class="custom-card" v-model="UploadedImage1" v-else>
              <v-img :src="Src1" ref="Image1" height="300"></v-img>
              <div class="close-icon" @click.stop="removeImage('thumbnail')">x</div>
            </v-card>
          </div>
          <input
            type="file"
            accept="image/png, image/gif, image/jpeg"
            style="display: none"
            ref="Img1"
            @change="SetImage1"
          />
        </div>
      </v-col>
      <v-col cols="12" md="8">
        <v-row>
          <v-col cols="12" md="12">
            <div class="pb-10">Course Banner required (1440 x 400px)</div>
            <div>
              <div @click="UploadImg2">
                <div class="dashed" v-if="Src2 == null">
                  <div class="d-flex justify-center py-10">
                    <div class="">
                      <camerasvg />
                    </div>
                  </div>
                </div>

                <v-card class="custom-card" v-model="UploadedImage2" v-else>
                  <v-img
                    :src="Src2"
                    ref="Image2"
                    height="185"
                    style="object-fit: fill"
                  ></v-img>
                  <div
                    class="close-icon"
                    @click.stop="removeImage('banner')"
                  >
                    x
                  </div>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img2"
                @change="SetImage2"
              />
            </div>
          </v-col>
        </v-row>
        <v-row>
          <div class="pt-5">Optional Additional Photos</div>
          <v-col cols="12" md="4">
            <div>
              <div @click="UploadImg3">
                <v-card
                  flat
                  color="transparent"
                  v-model="svgBackground3"
                  class="svgBackgroundSection"
                  style="overflow: hidden"
                  v-if="Src3 == null || Src3.includes('null')"
                >
                  <div style="height: 100%; position: relative">
                    <CameraBorderBoxSvg></CameraBorderBoxSvg>
                  </div>
                </v-card>
                <v-card class="custom-card" v-model="UploadedImage3" v-else>
                  <v-img :src="Src3" ref="Image3" height="185"></v-img>
                  <div
                    class="close-icon"
                    @click.stop="removeImage('image1')"
                  >
                    x
                  </div>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img3"
                @change="SetImage3"
              />
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="">
              <div @click="UploadImg4">
                <v-card
                  flat
                  color="transparent"
                  v-model="svgBackground4"
                  class="svgBackgroundSection"
                  style="overflow: hidden"
                  v-if="Src4 == null || Src4.includes('null')"
                >
                  <div style="height: 100%; position: relative">
                    <CameraBorderBoxSvg></CameraBorderBoxSvg>
                  </div>
                </v-card>
                <v-card class="custom-card" v-model="UploadedImage4" v-else>
                  <v-img :src="Src4" ref="Image4" height="185"></v-img>
                  <div
                    class="close-icon"
                    @click.stop="removeImage('image2')"
                  >
                    x
                  </div>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img4"
                @change="SetImage4"
              />
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <div class="">
              <div @click="UploadImg5">
                <v-card
                  flat
                  color="transparent"
                  v-model="svgBackground5"
                  class="svgBackgroundSection"
                  style="overflow: hidden"
                  v-if="Src5 == null || Src5.includes('null')"
                >
                  <div style="height: 100%; position: relative">
                    <CameraBorderBoxSvg></CameraBorderBoxSvg>
                  </div>
                </v-card>
                <v-card class="custom-card" v-model="UploadedImage5" v-else>
                  <v-img :src="Src5" ref="Image5" height="185"></v-img>
                  <div
                    class="close-icon"
                    @click.stop="removeImage('image3')"
                  >
                    x
                  </div>
                </v-card>
              </div>

              <input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                style="display: none"
                ref="Img5"
                @change="SetImage5"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CameraBorderBoxSvg from "../../assets/SvgIcons/CameraborderboxSvg.vue";
import Camerasvg from "../../assets/SvgIcons/camerasvg.vue";
export default {
  props: ["CourseImage"],
  name: "BlogImageUploaderComponent",
  components: { CameraBorderBoxSvg, Camerasvg },
  watch: {
    CourseImage: {
      handler: function () {
        if (this.CourseImage) {
          setTimeout(() => {
            this.Src1 = this.CourseImage.Thumbnail;
            this.Src2 = this.CourseImage.Banner;
            this.Src3 = this.CourseImage.Image1;
            this.Src4 = this.CourseImage.Image2;
            this.Src5 = this.CourseImage.Image3;
          }, 100);
        }
      },
    },
  },
  mounted() {
    if (this.CourseImage) {
      setTimeout(() => {
        this.Src1 = this.CourseImage.Thumbnail;
        this.Src2 = this.CourseImage.Banner;
        this.Src3 = this.CourseImage.Image1;
        this.Src4 = this.CourseImage.Image2;
        this.Src5 = this.CourseImage.Image3;
      }, 100);
    }
  },

  data() {
    return {
      ThumbnailImg: "",
      BannerImg: "",
      OptionalImage1: "",
      OptionalImage2: "",
      OptionalImage3: "",

      svgBackground1: true,
      UploadedImage1: false,
      img1: {},
      Src1: null,

      svgBackground2: true,
      UploadedImage2: false,
      img2: {},
      Src2: null,

      svgBackground3: true,
      UploadedImage3: false,
      img3: {},
      Src3: null,

      svgBackground4: true,
      UploadedImage4: false,
      img4: {},
      Src4: null,

      svgBackground5: true,
      UploadedImage5: false,
      img5: {},
      Src5: null,
    };
  },
  methods: {
    UploadImg1() {
      this.$refs.Img1.click();
    },

    SetImage1() {
      console.log(this.$refs.Img1);
      var reader = new FileReader();
      reader.onload = () => {
        this.Src1 = reader.result;
        // Convert image to base64
        const base64Image = reader.result.split(",")[1];
        this.$emit("SetThumbnail", {
          file: this.$refs.Img1.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img1.files[0]);
    },
    
    removeImage(imageType) {
      switch (imageType) {
        case 'thumbnail':
          this.Src1 = null;
          this.$refs.Image1.value = "";
          this.$emit("SetThumbnail", "");
          break;
        case 'banner':
          this.Src2 = null;
          this.$refs.Image2.value = "";
          this.$emit("SetBanner", "");
          break;
        case 'image1':
          this.Src3 = null;
          this.$refs.Image3.value = "";
          this.$emit("SetImage1", "");
          break;
        case 'image2':
          this.Src4 = null;
          this.$refs.Image4.value = "";
          this.$emit("SetImage2", "");
          break;
        case 'image3':
          this.Src5 = null;
          this.$refs.Image5.value = "";
          this.$emit("SetImage3", "");
          break;
      }
    },
    UploadImg2() {
      this.$refs.Img2.click();
    },

    UploadImg3() {
      this.$refs.Img3.click();
    },

    UploadImg4() {
      this.$refs.Img4.click();
    },

    UploadImg5() {
      this.$refs.Img5.click();
    },

    SetImage2() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src2 = reader.result;
        // Convert image to base64
        const base64Image = reader.result.split(",")[1];
        this.$emit("SetBanner", {
          file: this.$refs.Img2.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img2.files[0]);
    },

    SetImage3() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src3 = reader.result;
        // Convert image to base64
        const base64Image = reader.result.split(",")[1];
        this.$emit("SetImage1", {
          file: this.$refs.Img3.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img3.files[0]);
    },

    SetImage4() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src4 = reader.result;
        // Convert image to base64
        const base64Image = reader.result.split(",")[1];
        this.$emit("SetImage2", {
          file: this.$refs.Img4.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img4.files[0]);
    },

    SetImage5() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src5 = reader.result;
        // Convert image to base64
        const base64Image = reader.result.split(",")[1];
        this.$emit("SetImage3", {
          file: this.$refs.Img5.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img5.files[0]);
    },
  },
};
</script>

<style scoped>
.dashed {
  border: 0.2px dashed #cacacd;
  border-style: 0.2px dashed;
  border-radius: 10px;
  max-height: 400px;
  opacity: 0.48;
  align-items: center;
}

.svgBackgroundSection {
}
h1 {
  font-family: "DM Sans";
  font-size: 30px;
  font-weight: 400;
  line-height: 39px;
}
.custom-card {
  position: relative;
}

.close-icon {
  position: absolute;
  padding-bottom: 3px;
  top: -9px;
  right: -9px;
  cursor: pointer;
  display: flex;
  height: 20px;
  width: 20px;
  font-size: 25px;
  justify-content: center;
  align-items: center;
  line-height: 0px;
  border-top-left-radius: 20%;
  border-top-right-radius: 20%;
  background-color: rgba(170, 168, 168, 0.704);
}

/* .check {
  background-image: url("../../assets/css/rect.svg");
  background-repeat: no-repeat;
  background-size: ;
  display: flex;
  align-items: center;
} */
</style>
